import { useEffect } from 'react';
import {
    shouldResetConversation,
    clearConversationLocalStorage,
    convKey,
    msgsKey,
    deletedMsgsKey
} from '../utils/aiChatUtils';

/**
 * 会話履歴のローカルストレージ管理フック
 * @param {object} user - ユーザーオブジェクト
 * @param {string} conversationId - 会話ID
 * @param {array} messages - メッセージ配列
 * @param {function} setConversationId - 会話ID設定関数
 * @param {function} setMessages - メッセージ設定関数
 * @returns {object} キー生成関数
 */
export function useAIConversationStorage(user, conversationId, messages, setConversationId, setMessages) {
    // user確定後に per-user のローカルキャッシュを読み込む（他ユーザーの表示を防ぐ）
    useEffect(() => {
        if (!user?.login_id) return;
        try {
            // 地図などから reset フラグ付きで来た場合は復元せず LS もクリア
            // （復元とリセットのレースで UI が固まるのを防ぐ。最終クリアは handleNewConversation 側）
            if (shouldResetConversation()) {
                clearConversationLocalStorage(user.login_id);
                setConversationId("");
                setMessages([]);
                return;
            }

            const cid = localStorage.getItem(convKey(user.login_id)) || "";
            const raw = localStorage.getItem(msgsKey(user.login_id));
            const parsed = raw ? JSON.parse(raw) : [];
            setConversationId(cid);
            setMessages(Array.isArray(parsed) ? parsed : []);
        } catch (_) {
            // noop
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.login_id]);

    // conversationId を保存（user単位）
    useEffect(() => {
        if (!user?.login_id) return;
        if (shouldResetConversation()) return;
        if (conversationId) {
            try {
                localStorage.setItem(convKey(user.login_id), conversationId);
            } catch (_) {
                // noop
            }
        }
    }, [conversationId, user?.login_id]);

    // messages を保存（user単位）。reset 中は中間状態を書かない
    useEffect(() => {
        if (!user?.login_id) return;
        if (shouldResetConversation()) return;
        try {
            localStorage.setItem(msgsKey(user.login_id), JSON.stringify(messages));
        } catch (_) {
            // noop
        }
    }, [messages, user?.login_id]);

    return {
        convKey,
        msgsKey,
        deletedMsgsKey
    };
}
